import React, { Component } from "react";
import dayjs from "dayjs";
import { isNullOrUndefined } from "../../HWLibrary/HWUtils";
import MainMenu from '../../../images/MainMenu.svg'
import homeImage from '../../../images/home.png'
// import { display } from "@mui/system";
import { Tooltip } from "react-bootstrap";
import { Typography } from "@material-ui/core";
class MessageA77 extends Component {
    constructor(props) { super(props); }
    
    render() {
         let text = (this.props.entry && this.props.entry.text) || "";
    //    let text =`<img src="https://picsum.photos/id/237/200/300">`
        if (this.props.entry && this.props.entry.keyword) { text = text; }
        return (
            <div className={this.messageContainerClassName()} style={this.messageContainerStyle()}>
               
                <button disabled={this.props.disabled} title="Main Menu" className={this.messageBoxClassName()+" btn-check"} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}  style={this.messageBoxStyle()}  {...(this.isActiveConversation() && {onClick:(e)=> this.onMessageSend(e)})}>
                
                   {/* <img id="mainMenuSVG" src={MainMenu}></img> */}
                  {isNullOrUndefined(this?.props?.config?.mainMenuMessage) ? "I would like to return to main menu":  this?.props?.config?.mainMenuMessage} 
                    <br />
                 
                </button>
                {  this.props.isLastEntry && this.props.sentTimestamp&& <div className={this.messageTimeClassName()} style={this.messageTimeStyle()}>{dayjs.unix(Math.trunc(this.props.sentTimestamp/1000)).format("DD MMM h:mm a")}</div>}
            </div>
        )
    }

    mainMenuSVG =()=>{
        let config          = this.props.config;
        const designDetials = this.props.config.designDetails;
        return(
            <svg width="24" height="24" viewBox="0 0 24 24" fill="#FFF" xmlns="http://www.w3.org/2000/svg">
<circle cx="17" cy="8" r="4" fill="#FFF"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M15 8C15 6.89543 15.8954 6 17 6C18.1046 6 19 6.89543 19 8H15ZM11 8C11 7.29873 11.1203 6.62556 11.3414 6H5C4.44772 6 4 6.44772 4 7C4 7.55228 4.44772 8 5 8H11ZM11.8027 11C12.2671 11.8028 12.9121 12.488 13.6822 13H5C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11H11.8027ZM5 16C4.44772 16 4 16.4477 4 17C4 17.5523 4.44772 18 5 18H19C19.5523 18 20 17.5523 20 17C20 16.4477 19.5523 16 19 16H5Z" fill="#FFF"/>
</svg>
        )
    }

    onMouseEnter = (e) => {
        if (!e.target) { return }
        if (e.target.disabled === true) { return }
        const designDetails = this.props.config.designDetails;
        e.target.style.color           = isNullOrUndefined(designDetails.buttonHighlightTextColor)       ? "#f8f5f5" : designDetails.buttonHighlightTextColor;
        e.target.style.backgroundColor = isNullOrUndefined(designDetails.buttonHighlightBackgroundColor) ? "#2935dd" : designDetails.buttonHighlightBackgroundColor;
    }

    onMouseLeave = (e) => {
        if (!e.target) { return }
        // if (e.target.disabled === true) { return }
        const designDetails = this.props.config.designDetails;
        e.target.style.color           = isNullOrUndefined(designDetails.buttonTextColor)       ? "#0092ed" : designDetails.buttonTextColor;
        e.target.style.backgroundColor = isNullOrUndefined(designDetails.buttonBackgroundColor) ? "#fff" : designDetails.buttonBackgroundColor;
    }

    messageTimeClassName = () => {
        return "s360-message-time-received";
        // switch (this.props.message.type) {
        //     // case MessageType.sent: return "s360-message-time-sent";
        //     // case MessageType.received: return "s360-message-time-received";
        //     // case MessageType.info: return "s360-message-time-info";
        //     default: return "";
        // }
    }

    messageBoxClassName = () => {
        //return "s360-message-box-received";
        return "btn btn-chat";
        // switch (this.props.message.type) {
        //     case MessageType.sent: return "s360-message-box-sent";
        //     case MessageType.received: return "s360-message-box-received";
        //     case MessageType.info: return "s360-message-box-info";
        //     default: return "";
        // }
    }

    messageContainerClassName = () => {
        return this.props.config.autoFullScreen
        ? "s360-message-cotainer-received-fs"
        : "s360-message-cotainer-received";
        // switch (this.props.message.type) {
        //     case MessageType.sent: return "s360-message-cotainer-sent";
        //     case MessageType.received: return "s360-message-cotainer-received";
        //     case MessageType.info: return "s360-message-cotainer-info";
        //     default: return "";
        // }
    }
    

    messageBoxStyle = () => {
        let config          = this.props.config;
        const designDetials = this.props.config.designDetails;
        let styleData = { 
            // background: config.designDetails.senderMessageColor, 
            fontFamily: config.designDetails.SenderMessageFont, 
            fontSize: config.designDetails.SenderMessageFontSize, 
            borderWidth:"1px", 
            borderStyle: "solid",
            // color: config.designDetails.senderMessageFontColor,
            // height:          isNullOrUndefined(designDetials.buttonHeight)          ? "auto" : designDetials.buttonHeight,
            borderColor: isNullOrUndefined(designDetials.buttonBorderColor) ? "#0092ed" : designDetials.buttonBorderColor,
            width:           isNullOrUndefined(designDetials.buttonWidth)           ? "100%" : designDetials.buttonWidth,
            borderRadius:    isNullOrUndefined(designDetials.mainMenubuttonBorderRadius)    ? 40 : designDetials.mainMenubuttonBorderRadius,
            color:           isNullOrUndefined(config.designDetails.senderMessageFontColor)       ? "#0092ed" : designDetials.buttonTextColor,
            backgroundColor: isNullOrUndefined(designDetials.buttonBackgroundColor) ? "#fff" : designDetials.buttonBackgroundColor,
            fontWeight:isNullOrUndefined(designDetials.senderFontWeight) ? "600":designDetials.senderFontWeight,
            display:'flex',
            flexDirection:'row',
            justifyContent:'space-evenly',
            alignItems:'center',
            height:'35px'
            
            // boxShadow:'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px inset'
        }
        // switch (this.props.message.type) {
        //     case MessageType.received: return { background: config.designDetails.senderMessageColor, fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageFontSize, color: config.designDetails.senderMessageFontColor }
        //     case MessageType.sent: return { background: config.designDetails.recieverMessageColor, fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageFontSize, color: config.designDetails.recieverMessageFontColor }
        //     case MessageType.info: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
        //     default: return {}
        // }
        return styleData;
    }

    messageContainerStyle = () => {
       

        // let config = this.props.config
        return {
            
        }
    }

    messageTimeStyle = () => {
        let config = this.props.config;
        return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageTimeFontColor}
        // let fontSize = config.designDetails.messageFontSize - (config.designDetails.messageFontSize / 4);
        // switch (this.props.message.type) {
        //     case MessageType.received: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
        //     case MessageType.sent: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
        //     case MessageType.info: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
        //     default: return {}
        // }
    }


    onMessageSend = () => {
        this.props.actions.sendMessageWithCode(this.props.entry.keyword, "I would like to Return to main menu");
        var n = document.getElementsByClassName("btn btn-chat");
        
        for(var i=0;i<n.length;i++){
            n[i].disabled = true;
            // this.onMouseLeave({ "target": n[i]});
         }
         document.getElementById(".mainMenuSVG").attr("onclick", "").unbind("click");
        
         
       
        
    }


    isActiveConversation = () => {

        let isClosed = (this.props.activeConversation && this.props.activeConversation.active != null && this.props.activeConversation.active !== undefined && this.props.activeConversation.active === false) || this.props.isConversationClosed;
        return !isClosed;
    }

}

export default MessageA77;